import { ContactContainer } from './Contact';
import { BillingContactContainer } from './BillingContact';
import { ServicesContainer } from './Services';
import { StartsOnContainer } from './StartsOn';
import { NONGLSContainer } from './Users/NONGLS';
import { ErrorMessages } from '@/components/pages/Subscription/Presentation/Form/Field/Users/ErrorMessages';
import { Admins } from '@/components/pages/Subscription/Presentation/Form/Field/Admins';
import { ProjectClassesContainer } from './ProjectClassesContainer';
import { BillingNote } from './BillingNote';

// TODO: rename
export const Field = {
  ContactField: ContactContainer,
  BillingContactField: BillingContactContainer,
  ServicesField: ServicesContainer,
  StartsOnField: StartsOnContainer,
  BillingNoteField: BillingNote,
  UsersField: {
    NONGLS: NONGLSContainer,
    ErrorMessages,
  },
  AdminsField: Admins,
  ProjectClassesField: ProjectClassesContainer,
};
